module.exports = __webpack_public_path__ + "img/icon_map_7_on_011.22f99963.png";